<div class="client-container">
  <div class="title">
    <div class="no-show">{{clientEdit|json}}</div>
    <span>
      {{condition}}
    </span>
  </div>
  <hr>
  <form [formGroup]="formClient" (ngSubmit)="onSubmit(formClient.value)">
    <div class="form-control">
      <div class="form-control-label">
        <span>Code</span>
      </div>
      <div class="form-control-name">
        <input #_code formControlName="code" class="input-control" type="text" value="{{clientEdit?.code}}"
          maxlength="25">
        <div *ngIf="code.invalid && (code.dirty || code.touched)">
          <div class="error-message" *ngIf="code.errors.required">
            required field
          </div>
        </div>
      </div>
    </div>
    <div class="form-control">
      <div class="form-control-label">
        <span>Name</span>
      </div>
      <div class="form-control-name">
        <input #_name formControlName="name" class="input-control" type="text" value="{{clientEdit?.name}}"
          maxlength="60">
        <div *ngIf="name.invalid && (name.dirty || name.touched)">
          <div class="error-message" *ngIf="name.errors.required">
            required field
          </div>
        </div>
      </div>
    </div>
    <div class="form-control">
      <div class="form-control-label">
        <span>Parent</span>
      </div>
      <div class="form-control-name">
        <select #_parentId formControlName="parentId" class="select-control">
          <option value="{{clientParent.id}}" *ngFor="let clientParent of clientList"
            [selected]="clientParent?.selected === true">
            {{clientParent.name}}
          </option>
        </select>
      </div>
    </div>
    <div class="form-control">
      <div class="form-control-label">
        <span>Type</span>
      </div>
      <div class="form-control-name">
        <select #_typeId formControlName="typeId" class="select-control">
          <option [value]="clientType.id" *ngFor="let clientType of clientTypesList"
            [selected]="clientType?.selected === true">
            {{clientType.name}}
          </option>
        </select>
        <div *ngIf="typeId.invalid && (typeId.dirty || typeId.touched)">
          <div class="error-message" *ngIf="typeId.errors.required">
            required field
          </div>
        </div>
      </div>
    </div>
    <div class="form-control">
      <div class="form-control-label">
        <span>Gov Number</span>
      </div>
      <div class="form-control-name">
        <input #_govNumber formControlName="govNumber" [value]=clientEdit?.govNumber class="input-control" type="text"
          maxlength="8" (paste)="validatePaste($event)" (keypress)="validate($event)">
      </div>
    </div>
    <div class="form-control">
      <button type="submit">Save</button>
      <button type="button" (click)="Cancel()">Cancel</button>
    </div>
  </form>
</div>
